<template>
  <div class="queue-holder">
    <MarketingItem
      v-for="(resource, index) in selectedResources"
      :key="index"
      :num="index"
      :resource="resource"
      display="queue"
    />
  </div>
  <div
    class="download-button"
    title="Download Items"
    @click="downloadResources()"
    v-if="!getQueueState"
  >
    <div class="download-text">
      DOWNLOAD SELECTION
    </div>
    <div class="download">
      <img
        :src="require('@/assets/svg/SVG/download.svg')"
        alt="Download"
      >
    </div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import MarketingItem from '@/components/libraries/search/MarketingItem';
import { mapStores } from 'pinia';

export default {
  name: 'ItemQueue',
  components: {
    MarketingItem
  },
  computed: {
    ...mapStores(useRMTStore),
    selectedResources () {
      return this.RMTStore.selectedResources;
    },
    getQueueState () {
      return this.RMTStore.inCreateCollectionMode;
    }
  },
  methods: {
    downloadResources () {
      this.RMTStore.downloadResourcesZip();
    }
  }
};
</script>

<style scoped>
.queue-holder {
	padding: 3px 0;
  margin-top: 30px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
/*  flex-wrap: wrap;*/
  overflow-y: auto;
  max-height: 316px;
  background-color: white;
  border: 1px solid black;
}
.img-t {
  width: 100px;
  height: 100px;
  background-color: #595a5a;
  margin: 5px;
}
.download-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 5px 0px;
  align-items: right;
}
.download-text {
  text-align: right;
  margin-right: 4px;
  width: 100%;
  text-transform: Uppercase;
  font-size: .8em;
  font-weight: bold;
  letter-spacing: .05em;
}
.download {
  text-align: right;
  width: 14px;
  height: 14px;
}
</style>